import { ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { getAvailabilityStoresFailed, getAvailabilityStoresSuccess } from '@redux/actions/bopis/getAvailabilityStores';
import { GET_AVAILABILITY_STORES_START } from '@redux/actions/bopis/getAvailabilityStores/types';
import { getBOPISFreeGiftAvailabilityStoresStart } from '@redux/actions/bopis/getBOPISFreeGiftAvailabilityStores';
import { postAsObservable } from '@services/genericService';
import { GET_AVAILABILITY_STORES_TYPE } from '@utils/constant';

import { GET_AVAILABILITY_STORES_ENDPOINT } from './configs';

const getAvailabilityStoresEpic = (action$) => action$.pipe(
  ofType(GET_AVAILABILITY_STORES_START),
  switchMap((action) => {
    const payload = {
      ListProducts: [...action.payload.ListProducts],
      Type: action.payload.Type
    };

    return from(postAsObservable(GET_AVAILABILITY_STORES_ENDPOINT, payload))
      .pipe(
        switchMap((res) => {
          if (res.status === 200) {
            if (action.payload.FreeGiftsList?.length) {
              return of(
                getAvailabilityStoresSuccess(res.data),
                getBOPISFreeGiftAvailabilityStoresStart({ Type: GET_AVAILABILITY_STORES_TYPE.Or, ListProducts: action.payload.FreeGiftsList })
              );
            } else {
              return of(getAvailabilityStoresSuccess(res.data));
            }
          }

          return getAvailabilityStoresFailed('Failed');
        }),
        catchError((error) => of(getAvailabilityStoresFailed(error.message || 'Failed')))
      );
  })
);

export default getAvailabilityStoresEpic;